import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmployeesServiceProvider } from '../../api/employees'

const EmployeesService = EmployeesServiceProvider()
const name = 'deleteEmployee'

export default (id) => (asyncAction(
  name,
  EmployeesService.deleteEmployee,
  { id }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/employee/deleteEmployee.js